export const ProductInterestPrefillFieldsConstant = {
    userId: 'userId',
    customerId: 'customerId',
    product: 'product'
};